import { Component } from '@angular/core';

import { FiltersService } from './filters.service';
import { ExperienceFinderStateService } from '@hiptraveler/features/experience-finder';
import { getFiltersService } from '../../search-filter-ref';

@Component({
  selector: 'filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  viewProviders: [ FiltersService ]
})
export class FiltersComponent2 {

  constructor(
    public service: FiltersService,
    public stateService: ExperienceFinderStateService
  ) { }

  clearFilters(): void {
    this.service.form.reset();
    const filters = getFiltersService();
    filters.form.patchValue({ query: '', checkInDate: '', checkOutDate: '' });
  }

}
